import { progressAtom, serverLoadingAtom } from "@/hooks/headerHooks";
import { useRemoveLangFromPath } from "@/hooks/useRemoveLangFromPath";
import { useAtom } from "jotai";
import {
  ReadonlyURLSearchParams,
  usePathname,
  useSearchParams,
} from "next/navigation";

const useIsRouterChanged = () => {
  const removeLangFromPath = useRemoveLangFromPath();
  const isRouterChanged = (
    href: string,
    pathname: string,
    searchParams: ReadonlyURLSearchParams,
  ) => {
    if (href.startsWith("http"))
      return { startProgress: false, loading: false };
    const url = removeLangFromPath(`${pathname}`, true).replaceAll("/", "");
    const hrefStr = removeLangFromPath(`${href}`, true).replaceAll("/", "");
    const index = hrefStr.indexOf("?");
    const hrefPath = index < 0 ? hrefStr : hrefStr.substring(0, index);
    const hrefParams = index < 0 ? "" : href.substring(index + 1);
    return {
      startProgress: hrefPath !== url,
      loading: hrefPath === url && hrefParams !== searchParams.toString(),
    };
  };
  return isRouterChanged;
};

export const useRouterChange = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [, setProgress] = useAtom(progressAtom);
  const [, setServerLoading] = useAtom(serverLoadingAtom);
  const isRouterChanged = useIsRouterChanged();
  const setRouterChange = (href: string) => {
    const { startProgress, loading } = isRouterChanged(
      href?.toString(),
      pathname!,
      searchParams!,
    );
    setProgress(startProgress);
    setServerLoading(loading);
  };
  return { setRouterChange };
};
